import { observer } from 'mobx-react-lite';
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Icon, Image } from 'semantic-ui-react';
import { UserActivity } from '../../app/models/userActivity';
import FollowTaglleButton from './FollowTaglleButton';

interface Props {
    profile: UserActivity;
}

function ProfileCard(props: Props) {
    function truncateStr(str: string | undefined) {
        if (str) {
            return str.length < 40 ? str : str.substring(0, 37) + '...' ;
        }
    }

    return (
        <Card as={Link} to={`/profiles/${props.profile.userName}`} >
            <Image src={props.profile.photoUrl || `/assets/user.png`} />
            <Card.Content>
                <Card.Header>{props.profile.displayName}</Card.Header>
                {props.profile.bio && (
                    // <Card.Description>{props.profile.bio.length < 40 ? props.profile.bio : props.profile.bio.substring(0, 37) + '...' }</Card.Description>
                    <Card.Description>{truncateStr(props.profile.bio)}</Card.Description>
                )}
            </Card.Content>
            <Card.Content extra>
                <Icon name='user'/>
                {props.profile.followersCount + 50} followers
            </Card.Content>
            <FollowTaglleButton profile={props.profile} />
        </Card>
    )
}

export default observer(ProfileCard);